import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/sections/Nav";
import Hero from "@/sections/Hero";
import HowItWorks from "@/sections/HowItWorks";
import ProductsSection from "@/sections/ProductsSection";
import ServiceLayer from "@/sections/ServiceLayer";
import HomePricing from "@/sections/HomePricing";
import Partners from "@/sections/Partners";
import Founder from "@/sections/Founder";
import FinalCta from "@/sections/FinalCta";
import Footer from "@/sections/Footer";
import FieldServices from "@/pages/FieldServices";
import PricingPage from "@/pages/Pricing";
import ServicesPage from "@/pages/Services";
import ContactPage from "@/pages/Contact";
import { PrivacyPage, TermsPage } from "@/pages/Legal";

const HomePage = () => (
  <>
    <Nav />
    <main>
      <Hero />
      <HowItWorks />
      <ProductsSection />
      <ServiceLayer />
      <HomePricing />
      <Partners />
      <Founder />
      <FinalCta />
    </main>
    <Footer />
  </>
);

export default function App() {
  const path = window.location.pathname;

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const hash = a.getAttribute("href");
      if (hash && hash.length > 1 && document.querySelector(hash)) {
        e.preventDefault();
        lenis.scrollTo(hash, { offset: -64 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView(), 500);
    }
  }, []);

  let page;
  if (path.startsWith("/field-services")) page = <FieldServices />;
  else if (path.startsWith("/pricing")) page = <PricingPage />;
  else if (path.startsWith("/services")) page = <ServicesPage />;
  else if (path.startsWith("/contact")) page = <ContactPage />;
  else if (path.startsWith("/privacy")) page = <PrivacyPage />;
  else if (path.startsWith("/terms")) page = <TermsPage />;
  else page = <HomePage />;

  return (
    <div className="App bg-white text-ink font-sans antialiased">
      {page}
      <Toaster position="top-center" theme="light" />
    </div>
  );
}
